import JoiningMeeting from './JoiningMeeting';

export default JoiningMeeting;
